import React, { useState } from "react";
import SearchOCField from "./SearchOCField";
import ModalOC from "./ModalOC";
import PropTypes from 'prop-types';
import Confirm from "../Confirm";
import TextField from '@material-ui/core/TextField';
import LoadingOrderClient from '../../api/loading-order';
import { toastError, toastSuccess } from '../../utils/Swal';
import { connect } from "react-redux";

import useStyles from "./styles";
function SearchOCPanel({ canResetOC, clearLoadingOrder, resetLoadingOrderDocument, setNoCache }) {
    const classes = useStyles();
    const [loadingOrder, setLoadingOrder] = useState({});
    const [loadingOrderEditing, setLoadingOrderEditing] = useState({});
    const [loadingConfirmReset, setLoadingConfirmReset] = useState({});
    const [isSearching, setSearching] = useState(false);
    const [textReason, setTextReason] = useState('');

    const handleModalClearClose = async result => {
        if (result) {
            setLoadingOrderEditing({});
            try {
                await clearLoadingOrder(loadingOrderEditing.id, textReason);
                toastSuccess({ text: "Ordem de carregamenta reiniciada com sucesso!" });
                setTextReason('');
            } catch (error) {
                toastError({ text: error.message });
            }
        } else {
            setLoadingOrderEditing({});
            setTextReason('');
        }
    }

    function handleClearOC() {
        setLoadingOrderEditing({ ...loadingOrder });
    }

    function handleResetOC() {
        setLoadingConfirmReset({ ...loadingOrder });
    }

    async function hdlConfirmResetOC(option) {
        if(option) {
            await resetLoadingOrderDocument(loadingConfirmReset.id);
        }
        setLoadingConfirmReset({});
        setLoadingOrder({});
        toastSuccess({text: 'Document removido!'});
        setNoCache();
    }

    async function handleSearch(loadingOrderNumber) {
        if (loadingOrderNumber) {
            setSearching(true);
            const { data } = await LoadingOrderClient.searchLoadingOrder(loadingOrderNumber);
            setSearching(false);
            if (data && Object.keys(data).length) {
                if (data.error) {
                    toastError({ text: data.error.message });
                }

                setLoadingOrder(data);
                return;
            } else {
                toastError({ text: "Ordem de carregamento não encontrada!" });
            }
        }
        setLoadingOrder({});
    }

    return (<>
        <SearchOCField disabled={isSearching} isClearable={false} handleSearch={handleSearch} />
        <ModalOC
            open={(!!loadingOrder && !!loadingOrder.id) || loadingOrder.error}
            loadingOrder={loadingOrder}
            canResetOC={canResetOC && !loadingOrder.documents_checkout_date && !loadingOrder.error}
            handleClearOC={handleClearOC}
            handleResetOC={handleResetOC}
            data-cy="modal-oc-search"
            id="modal-oc-search"
            handleClose={() => setLoadingOrder({})} />
        <Confirm
            isOpen={Object.keys(loadingOrderEditing).length !== 0}
            title="Confirmar re-inicio?"
            message="Forneça um motivo!<br><strong>Atenção</strong>, essa ação não podera ser desfeita! Deseja continuar?"
            okText="Sim"
            data-cy="search-oc-confirm"
            id="search-oc-confirm"
            cancelText="Não"
            okButtonDisabled={textReason.length === 0}
            handleClose={handleModalClearClose}
        >
            <TextField
                label="Motivo"
                data-cy="sarch-oc-reason"
                id="sarch-oc-reason"
                multiline
                rowsMax={5}
                className={classes.reasonField}
                value={textReason}
                onChange={event => setTextReason(event.target.value)}
                variant="outlined"
            />
        </Confirm>
        <Confirm 
            isOpen={Object.keys(loadingConfirmReset).length !== 0}
            title="Resetar documento"
            okText="Sim"
            data-cy="reset-document"
            id="reset-document"
            cancelText="Não"
            message="Deseja remover o documento <strong>Loading Order</strong> auto importado?"
            handleClose={hdlConfirmResetOC}
        />
    </>);
}

SearchOCPanel.propTypes = {
    canResetOC: PropTypes.bool.isRequired,
    clearLoadingOrder: PropTypes.func.isRequired,
    resetLoadingOrderDocument: PropTypes.func.isRequired,
};


const mapDispatch = (dispatch) => ({
    setNoCache: (payload = null) => dispatch.navigation.setNoCache(payload)
});

export default connect(null, mapDispatch)(SearchOCPanel);